import React from "react";
import { Check } from "lucide-react";

const STAGES = [
  ["placed", "Order Placed"], ["accepted", "Accepted"], ["preparing", "Preparing"],
  ["ready", "Ready"], ["out_for_delivery", "Out for Delivery"], ["delivered", "Delivered"],
];

export function OrderTimeline({ status }) {
  const order = STAGES.map(([k]) => k);
  const currentIdx = status === "cancelled" ? -1 : order.indexOf(status);
  if (status === "cancelled") return <div className="text-destructive font-medium text-sm" data-testid="timeline-cancelled">This order was cancelled.</div>;
  return (
    <div className="flex flex-col sm:flex-row sm:items-start gap-1 sm:gap-0" data-testid="order-timeline">
      {STAGES.map(([k, label], i) => {
        const done = i <= currentIdx;
        return (
          <div key={k} className="flex sm:flex-col sm:items-center sm:flex-1 gap-3 sm:gap-2">
            <div className="flex sm:flex-col items-center sm:w-full">
              <div className={`w-8 h-8 rounded-full flex items-center justify-center shrink-0 text-xs font-semibold ${done ? "bg-gold text-navy" : "bg-beige text-muted-foreground border border-black/10"}`}>
                {done ? <Check size={15} /> : i + 1}
              </div>
              {i < STAGES.length - 1 && <div className={`hidden sm:block h-0.5 w-full ${i < currentIdx ? "bg-gold" : "bg-black/10"}`} style={{ marginTop: "-16px" }} />}
            </div>
            <div className={`text-xs pb-3 sm:pb-0 sm:text-center ${done ? "text-navy font-medium" : "text-muted-foreground"}`}>{label}</div>
          </div>
        );
      })}
    </div>
  );
}
